import { AvcInstanceTask, AvcInstanceTaskStateEnum } from '@nativewaves/nw-cloud-sdk/content'

export const speedtestDone: AvcInstanceTaskStateEnum[] = [
  AvcInstanceTaskStateEnum.Completed,
  AvcInstanceTaskStateEnum.Failed,
  AvcInstanceTaskStateEnum.Stopped,
]

export const formatSpeedtestData = (speedtest?: AvcInstanceTask) => {
  const status = speedtest?.status?.speedtestStatus

  return {
    download: status?.downloadBandwidth
      ? `${Math.round((status.downloadBandwidth / 1000000) * 100) / 100} Mbit/s`
      : undefined,
    upload: status?.uploadBandwidth
      ? `${Math.round((status.uploadBandwidth / 1000000) * 100) / 100} Mbit/s`
      : undefined,
    ping: status?.ping ? `${Math.round(status.ping * 1000 * 100) / 100} ms` : undefined,
    timestamp: status?.timestamp,
    speedtestInProgress: speedtest?.state ? !speedtestDone.includes(speedtest?.state) : false,
    serverInformation: status?.serverInformation,
    clientInformation: status?.clientInformation,
  }
}
